export class BannersModel {
  constructor() {

  }

  // getBanners() {
  //   return new Promise((resolve, reject) => {
  //     APICRUD['banner'].Search('estado', '1', 'desc')
  //       .then(resolve)
  //       .catch(reject)
  //   })
  // }
  getBanners() {
    return new Promise((resolve, reject) => {
      if (window.innerWidth > 600) {
        resolve([
          ['/assets/img/banner/02/1.webp', '/planes'],
          ['/assets/img/banner/02/2.webp', '/planes'],
          ['/assets/img/banner/02/3.webp', '/planes'],
          ['/assets/img/banner/02/4.webp', '/planes'],
          ['/assets/img/banner/02/5.webp', '/planes'],
          ['/assets/img/banner/02/6.webp', '/planes'],
          ['/assets/img/banner/02/7.webp', '/planes'],
          ['/assets/img/banner/02/8.webp', '/planes'],
          ['/assets/img/banner/02/9.webp', '/planes']
        ])
      } else {
        resolve([
          ['/assets/img/banner/02/1-mobile.webp', '/planes'],
          ['/assets/img/banner/02/2-mobile.webp', '/planes'],
          ['/assets/img/banner/02/3-mobile.webp', '/planes'],
          ['/assets/img/banner/02/4-mobile.webp', '/planes'],
          ['/assets/img/banner/02/5-mobile.webp', '/planes'],
          ['/assets/img/banner/02/6-mobile.webp', '/planes'],
          ['/assets/img/banner/02/7-mobile.webp', '/planes'],
          ['/assets/img/banner/02/8-mobile.webp', '/planes'],
          ['/assets/img/banner/02/9-mobile.webp', '/planes']
        ])
      }
    })
  }
}
